import { makeStyles } from '@mui/styles';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import Typography from 'apollo-react/components/Typography';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { getWarnings } from '../../../../form-designer/selectors/common.selectors';
import { editEntityInfo } from '../../../actions/entity-designer.actions';
import { getEntityProp } from '../../../selectors/entity-designer.selectors';

const useStyles = makeStyles({
  rowLabel: {
    paddingTop: 8,
    paddingRight: 8,
    alignItems: 'center',
    width: 200,
  },
  rowColumn: {
    flex: 1,
    alignItems: 'center',
    '& div': {
      margin: 0,
    },
  },
});

const SelectControl = ({ prop, label, items, disabled }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const currentValue = useSelector((state) => getEntityProp(state, { prop }));
  const [value, setValue] = useState(currentValue);
  const errors = useSelector(getWarnings);
  const hasError = useMemo(() => errors.some((error) => error.instanceId === prop), [errors, prop]);

  useEffect(() => {
    setValue(currentValue);
  }, [currentValue]);

  const onChangeHandler = ({ target: { value: v } }) => {
    const _value = v.trim();

    if (_value === currentValue) {
      return;
    }

    dispatch(editEntityInfo({ prop, value: _value }));
  };
  return (
    <>
      <div className={classes.rowLabel}>
        <Typography>{translateString(label)}</Typography>
      </div>
      <div className={classes.rowColumn}>
        <Select
          size="small"
          fullWidth
          value={value}
          onChange={onChangeHandler}
          canDeselect={false}
          disabled={disabled}
          error={hasError}
        >
          {items.map((item) => (
            <MenuItem value={item} key={`rt-${item}`}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </div>
    </>
  );
};

export default SelectControl;
